export default {
    "html": require('./html').default,
    "css": require('./css').default,
    "cssTablet": require('./cssTablet').default,
    "cssMobile": require('./cssMobile').default,
    "scss": require('./scss').default,
    "scssTablet": require('./scssTablet').default,
    "scssMobile": require('./scssMobile').default
}